import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, Translate, byteSize, getSortState, openFile } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC, SORT } from 'app/shared/util/pagination.constants';
import { getEntities } from './maintenance-part.reducer';

export const MaintenancePart = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const maintenancePartList = useAppSelector(state => state.maintenancePart.entities);
  const loading = useAppSelector(state => state.maintenancePart.loading);
  const totalItems = useAppSelector(state => state.maintenancePart.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <PageHeader
        headingId="maintenance-part-heading"
        headingDataCy="MaintenancePartHeading"
        contentKey="fleetSenseApp.maintenancePart.home.title"
        buttonTextKey="fleetSenseApp.maintenancePart.home.createLabel"
        match={match}
      />
      <div className="table-responsive">
        {maintenancePartList && maintenancePartList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fleetSenseApp.maintenancePart.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('proof')}>
                  <Translate contentKey="fleetSenseApp.maintenancePart.proof">Proof</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('description')}>
                  <Translate contentKey="fleetSenseApp.maintenancePart.description">Description</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('km')}>
                  <Translate contentKey="fleetSenseApp.maintenancePart.km">Km</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('age')}>
                  <Translate contentKey="fleetSenseApp.maintenancePart.age">Age</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('hour')}>
                  <Translate contentKey="fleetSenseApp.maintenancePart.hour">Hour</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('replaced')}>
                  <Translate contentKey="fleetSenseApp.maintenancePart.replaced">Replaced</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.maintenancePart.part">Part</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.maintenancePart.maintenanceVehicle">Maintenance Vehicle</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {maintenancePartList.map((maintenancePart, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${maintenancePart.id}`} color="link" size="sm">
                      {maintenancePart.id}
                    </Button>
                  </td>
                  <td>
                    {maintenancePart.proof ? (
                      <div>
                        {maintenancePart.proofContentType ? (
                          <a onClick={openFile(maintenancePart.proofContentType, maintenancePart.proof)}>
                            <Translate contentKey="entity.action.open">Open</Translate>
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {maintenancePart.proofContentType}, {byteSize(maintenancePart.proof)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>{maintenancePart.description}</td>
                  <td>{maintenancePart.km}</td>
                  <td>{maintenancePart.age}</td>
                  <td>{maintenancePart.hour}</td>
                  <td>{maintenancePart.replaced ? 'true' : 'false'}</td>
                  <td>{maintenancePart.part ? <Link to={`part/${maintenancePart.part.id}`}>{maintenancePart.part.name}</Link> : ''}</td>
                  <td>
                    {maintenancePart.maintenanceVehicle ? (
                      <Link to={`maintenance-vehicle/${maintenancePart.maintenanceVehicle.id}`}>{maintenancePart.maintenanceVehicle.created}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${maintenancePart.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${maintenancePart.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${maintenancePart.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.maintenancePart.home.notFound">No Maintenance Parts found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={maintenancePartList && maintenancePartList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default MaintenancePart;
